export default __webpack_public_path__ + "static/media/rl-1-lqMAX.f7bbad5c.jpg";